import { useEffect, useRef } from 'react'

const RESET_MS = 2000
const IGNORED_SELECTOR = 'input, textarea, select, [contenteditable]'

function isTypingTarget(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest(IGNORED_SELECTOR) !== null
}

export function useKeySequence(sequence: readonly string[], onMatch: () => void): void {
  const onMatchRef = useRef(onMatch)
  onMatchRef.current = onMatch

  useEffect(() => {
    let buffer: readonly string[] = []
    let timer: ReturnType<typeof setTimeout> | undefined

    const handler = (event: KeyboardEvent): void => {
      if (isTypingTarget(event.target)) return
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        buffer = []
      }, RESET_MS)
      const key = event.key.length === 1 ? event.key.toLowerCase() : event.key
      buffer = [...buffer, key].slice(-sequence.length)
      if (buffer.length === sequence.length && buffer.every((k, i) => k === sequence[i])) {
        buffer = []
        onMatchRef.current()
      }
    }

    window.addEventListener('keydown', handler)
    return () => {
      window.removeEventListener('keydown', handler)
      if (timer) clearTimeout(timer)
    }
  }, [sequence])
}
